<template>
	<v-container class="pa-3">
		<template>
			<v-row v-for="(row, rowIndex) in brandRows" :key="rowIndex" no-gutters>
				<v-col v-for="brand in row"
					:key="brand.id"
					cols="12"
					sm="6"
					md="4"
					lg="3"
					class="pa-3">
					<AsiCard unwrapped
						@click="toggleBrand(brand.id)"
						class="d-flex flex-column text-center pa-3 rounded-lg"
						style="cursor:pointer">
						<v-img
							:src="brand.image.files[0].url"
							:alt="brand.name"
							contain
							:aspect-ratio="1"
						/>
					</AsiCard>
				</v-col>

				<v-col cols="12" v-if="expandedBrand && isExpandedRow(row)">
					<v-expand-transition>
						<AsiCard unwrapped class="pa-6">
							<h2 class="text-h4 mb-4">
								{{ expandedBrand.name }}
							</h2>

							<div v-if="expandedBrand.description">
								{{ descriptionTranslated(expandedBrand.description) }}
							</div>
						</AsiCard>
					</v-expand-transition>
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script lang="ts">
	import {Vue, Component} from 'vue-property-decorator';
	import {IBrandShopListEntry} from '@/models/brand/BrandShopModels';
	import {ITranslatedValue} from '@/models/translated-value/TranslatedValueModels';
	import AsiCard from "@/components/common/AsiCard.vue";
	import TranslatedValueHelper from "@/models/translated-value/TranslatedValueHelper";
	import Snackbar from "@/helpers/Snackbar";

	@Component({
		components: {AsiCard}
	})
	export default class BrandShopList extends Vue {
		private brands: IBrandShopListEntry[] = [];
		private expandedBrandId: string | null = null;
		private itemsPerRow: number = 4;

		async mounted(): Promise<void> {
			await this.loadBrands();
		}

		get brandRows(): IBrandShopListEntry[][] {
			const rows: IBrandShopListEntry[][] = [];

			for (let i = 0; i < this.brandsWithImages.length; i += this.itemsPerRow) {
				rows.push(this.brandsWithImages.slice(i, i + this.itemsPerRow));
			}

			return rows;
		}

		get expandedBrand(): IBrandShopListEntry | null {
			return this.brandsWithImages.find(
				b => b.id === this.expandedBrandId
			) || null;
		}

		get brandsWithImages(): IBrandShopListEntry[] {
			return this.brands.filter(brand => brand.image !== null);
		}

		private async loadBrands(): Promise<void> {
			this.brands = await this.$brandServiceShop.brands().catch(() => Snackbar.loadingError());
		}

		private toggleBrand(brandId: string): void {
			if (this.expandedBrandId === brandId) {
				this.expandedBrandId = null;
			} else {
				this.expandedBrandId = brandId;
			}
		}

		private isExpandedRow(row: IBrandShopListEntry[]): boolean {
			return row.some(brand => brand.id === this.expandedBrandId);
		}

		private descriptionTranslated(description: ITranslatedValue): string | null {
			return TranslatedValueHelper.get(description, this.$i18n.locale);
		}
	}
</script>

<style scoped lang="scss">

</style>
